"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationModal = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const schemas_1 = require("@dcl/schemas");
const decentraland_ui_1 = require("decentraland-ui");
const utils_1 = require("../../../modules/analytics/utils");
const AuthorizationModal_types_1 = require("./AuthorizationModal.types");
const utils_2 = require("./utils");
const LOADING_STATUS = [
    AuthorizationModal_types_1.AuthorizationStepStatus.LOADING_INFO,
    AuthorizationModal_types_1.AuthorizationStepStatus.PROCESSING,
    AuthorizationModal_types_1.AuthorizationStepStatus.WAITING
];
function AuthorizationModal({ authorization, requiredAllowance, currentAllowance, action, authorizationType, revokeStatus, grantStatus, confirmationStatus, error, confirmationError, network, authorizedContractLabel, targetContractLabel, translationKeys, onClose, onRevoke, onGrant, onAuthorized, onFetchAuthorizations }) {
    const analytics = (0, utils_1.getAnalytics)();
    const [analyticsTraceId] = (0, react_1.useState)((0, uuid_1.v4)());
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const [loading, setLoading] = (0, react_1.useState)();
    const [shouldReauthorize, setShouldReauthorize] = (0, react_1.useState)(false);
    const requiredAllowanceAsEth = (0, utils_2.getPriceInMana)(requiredAllowance);
    (0, react_1.useEffect)(() => {
        analytics.track('[Authorization Flow] Modal Opened', {
            action,
            requiredAllowance,
            traceId: analyticsTraceId
        });
    }, []);
    (0, react_1.useEffect)(() => {
        onFetchAuthorizations();
    }, [onFetchAuthorizations]);
    const handleRevokeToken = (0, react_1.useCallback)(() => {
        onRevoke(analyticsTraceId);
        analytics.track('[Authorization Flow] Authorize Revoke Click', {
            action,
            traceId: analyticsTraceId
        });
        setLoading(AuthorizationModal_types_1.AuthorizationStepAction.REVOKE);
    }, [onRevoke]);
    const handleGrantToken = (0, react_1.useCallback)(() => {
        onGrant(analyticsTraceId);
        analytics.track('[Authorization Flow] Authorize Grant Click', {
            action,
            traceId: analyticsTraceId
        });
        setLoading(AuthorizationModal_types_1.AuthorizationStepAction.GRANT);
    }, [onGrant]);
    const handleAuthorized = (0, react_1.useCallback)(() => {
        onAuthorized();
        analytics.track('[Authorization Flow] Confirm Transaction Click', {
            action,
            traceId: analyticsTraceId
        });
        setLoading(AuthorizationModal_types_1.AuthorizationStepAction.CONFIRM);
    }, [onAuthorized]);
    const steps = (0, react_1.useMemo)(() => {
        const authSteps = (0, utils_2.getSteps)({
            authorizationType,
            network,
            requiredAllowance,
            currentAllowance,
            authorization,
            authorizedContractLabel,
            translationKeys,
            targetContractLabel
        });
        return [
            ...authSteps,
            {
                title: (0, utils_2.getTranslation)(translationKeys, 'confirm_transaction.title', {
                    action: (0, utils_2.getTranslation)(translationKeys, 'action')
                }),
                action: (0, utils_2.getTranslation)(translationKeys, 'confirm_transaction.action'),
                status: confirmationStatus,
                actionType: AuthorizationModal_types_1.AuthorizationStepAction.CONFIRM,
                error: confirmationError,
                onActionClick: handleAuthorized
            }
        ]
            .map(step => {
            if (step.actionType === AuthorizationModal_types_1.AuthorizationStepAction.GRANT) {
                if (shouldReauthorize ||
                    (grantStatus === AuthorizationModal_types_1.AuthorizationStepStatus.ALLOWANCE_AMOUNT_ERROR &&
                        network === schemas_1.Network.ETHEREUM)) {
                    return Object.assign(Object.assign({}, step), { error: (0, utils_2.getTranslation)(translationKeys, 'insufficient_amount_error.message', {
                            price: requiredAllowanceAsEth
                        }), action: 'Revoke', status: revokeStatus, message: !LOADING_STATUS.includes(revokeStatus) ? (react_1.default.createElement("div", { className: "authorization-error" }, (0, utils_2.getTranslation)(translationKeys, 'insufficient_amount_error.message', { price: requiredAllowanceAsEth }))) : (undefined), actionType: AuthorizationModal_types_1.AuthorizationStepAction.REVOKE, testId: 'reauthorize-step', onActionClick: handleRevokeToken });
                }
                return Object.assign(Object.assign({}, step), { action: grantStatus === AuthorizationModal_types_1.AuthorizationStepStatus.DONE
                        ? undefined
                        : (0, utils_2.getTranslation)(translationKeys, 'set_cap.action'), error, status: grantStatus, onActionClick: handleGrantToken });
            }
            if (step.actionType === AuthorizationModal_types_1.AuthorizationStepAction.REVOKE) {
                return Object.assign(Object.assign({}, step), { action: revokeStatus === AuthorizationModal_types_1.AuthorizationStepStatus.DONE
                        ? undefined
                        : (0, utils_2.getTranslation)(translationKeys, 'revoke_cap.action'), error, status: revokeStatus, onActionClick: handleRevokeToken });
            }
            return step;
        })
            .map((step, index) => {
            return Object.assign(Object.assign({}, step), { isLoading: index === currentStep && LOADING_STATUS.includes(step.status), message: 'message' in step && step.message
                    ? step.message
                    : (0, utils_2.getStepMessage)(index, step.status, step.error, currentStep, requiredAllowanceAsEth, step.actionType, translationKeys), testId: 'testId' in step ? step.testId : `${step.actionType}-step` });
        });
    }, [
        grantStatus,
        revokeStatus,
        authorizationType,
        requiredAllowance,
        currentAllowance,
        network,
        action,
        confirmationStatus,
        confirmationError,
        authorizedContractLabel,
        shouldReauthorize,
        currentStep,
        error,
        handleGrantToken,
        handleRevokeToken,
        handleAuthorized
    ]);
    (0, react_1.useEffect)(() => {
        const currentStepData = steps[currentStep];
        if (currentStepData.status === AuthorizationModal_types_1.AuthorizationStepStatus.DONE &&
            currentStepData.actionType === loading) {
            if (shouldReauthorize) {
                setShouldReauthorize(false);
            }
            else {
                setCurrentStep(currentStep + 1);
                setLoading(undefined);
            }
        }
        // We only want to run this when there is a change in the current steps status
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [steps[currentStep].status]);
    (0, react_1.useEffect)(() => {
        if (grantStatus === AuthorizationModal_types_1.AuthorizationStepStatus.ALLOWANCE_AMOUNT_ERROR &&
            network === schemas_1.Network.ETHEREUM) {
            setShouldReauthorize(true);
        }
    }, [grantStatus, network, setShouldReauthorize]);
    return (react_1.default.createElement(decentraland_ui_1.AuthorizationModal, { onClose: onClose, currentStep: currentStep, steps: steps, header: (0, utils_2.getTranslation)(translationKeys, 'title', {
            action: (0, utils_2.getTranslation)(translationKeys, 'title_action')
        }) }));
}
exports.AuthorizationModal = AuthorizationModal;
//# sourceMappingURL=AuthorizationModal.js.map